/* eslint-disable */
export default {
  confirmation: 'Confirmación',
  confirmMergeToConference: '¿Agregar a la conferencia telefónica?',
  mergeToConference: 'Combinar',
  conferenceCall: 'Conferencia telefónica',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
